import {
  Component,
  Output,
  EventEmitter,
  SimpleChanges,
  OnInit,
  OnChanges,
  HostListener,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { ViewEncapsulation, ElementRef, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl, FormControl } from '@angular/forms';

import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { tap, map, startWith } from 'rxjs/operators';
import { retry, catchError } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';

import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { DeviceDetectorService } from 'ngx-device-detector';

import { DatePipe } from '@angular/common';

import * as tus from 'tus-js-client';
import { Gallery, GalleryItem, ImageItem, ThumbnailsPosition, ImageSize } from '@ngx-gallery/core';

import { environment } from '../../environments/environment';
import { Logger } from '@core';

import { AuthQuery } from '@app/auth/auth.query';

import { JournalService, Journal, JournalSingle, JournalTable, MailService, Mail } from '@core';
import { CookieService } from 'ngx-cookie-service';

import { AuthDataService } from '@app/auth/auth-data.service';
import { MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS_FACTORY } from '@angular/material/progress-spinner';

import { requireAtLeastOneCheckboxValidator } from '../@shared/validation/require-checkboxes-to-be-checked.validator';

import { ConfirmDialogComponent } from '../@shared/dialog/confirm-dialog/confirm-dialog.component';
import { ImageLightboxComponent } from '../@shared/dialog/image-lightbox/image-lightbox.component';
import { TranslateLandPipe } from '@app/@shared/pipe/translate-land.pipe';

import { MandatService, Mandat, MandatSingle, StatusMandat } from '../services/mandat.service';
import {
  TransferMandatService,
  TransferMandat,
  TransferMandatSingle,
  StatusTransfer,
  PlateRecon,
} from '../services/transfer.service';
import { ImageService, MandatImage, MandatImageTable } from '@app/services/image.service';

import { DataChangeMandateService } from '../mandat/changes-mandat.service';
import { NavigationListService } from '../services/navigation-list.service';
import { SettingsService, Settings } from '@app/services/settings.service';

import {
  StammdatenService,
  Stammdaten,
  Tatbestand,
  Street,
  Land,
  Bezirk,
  Hersteller,
  Farbe,
} from '@app/services/stammdaten.service';
import { fromJSDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar';

declare var bootstrap: any; // Declare bootstrap to avoid TypeScript errors

const log = new Logger('Login');

export interface LueckenValue {
  luecken: string[];
}

@Component({
  templateUrl: './mandat_edit.component.html',
  styleUrls: ['./mandat_edit.component.scss'],
})
export class MandatEditComponent implements OnInit {
  StatusMandat = StatusMandat;
  mandat: Mandat;
  @Input() mandat_id;

  @Input() _uid; // person_id
  @Input() _fid; // transfer_id
  @Input() _role;
  //@Input() _country;
  @Input() _isAdmin;

  aktenzeichen: string = '';

  journalItems: Journal[] = [];

  _accounting_link: string;

  stammdaten: Stammdaten = {
    farben: [],
    hersteller: [],
    streets: [],
    bezirke: [],
    lander: [],
    tatbestande: [],
    usage: 0,
  };
  filteredBezirke$: Observable<any[]>;

  @ViewChild('myPond') myPond: any;
  pondOptions = {
    class: 'my-filepond',
    credits: false,
    multiple: false,
    allowFileTypeValidation: true,
    acceptedFileTypes: ['image/png', 'image/jpeg'],
    labelFileTypeNotAllowed: 'File of invalid type: only JPG, PNG',
    fileValidateTypeLabelExpectedTypesMap: { 'image/jpeg': '.jpg', 'image/png': '.png' },
    allowImageValidateSize: true,
    imageValidateSizeMinWidth: 150,
    imageValidateSizeMinHeight: 150,
    allowImageResize: true,
    imageResizeTargetWidth: 2400,
    imageResizeTargetHeight: 1600,
    imageResizeMode: 'contain',
    imageResizeUpscale: true,
    imageCropAspectRatio: 1,
    labelIdle: 'Drop files here or <a style="text-decoration:underline;">Browse</a> ...',
    // acceptedFileTypes: ['image/jpeg, image/png'],
    server: {
      process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
        // fieldName is the name of the input field
        // file is the actual file object to send
        //debugger;
        //console.table(fieldName);
        const formData = new FormData();
        formData.append(fieldName, file, file.name);
        formData.append('filepond', file.name);

        formData.append('uid', '' + this._uid);
        formData.append('fid', '' + this._fid);
        formData.append('role', '' + this._role);
        formData.append('imgtype', '' + fieldName);

        const request = new XMLHttpRequest();
        request.open('POST', environment.serverUrl + '/filepond/process');

        // set `Content-Type` header
        //request.setRequestHeader('Content-Type', 'application/json');
        request.setRequestHeader('Access-Control-Allow-Origin', '*');
        //xhr.setRequestHeader('Accept', "application/json");
        request.setRequestHeader('Access-Control-Allow-Headers', '*');

        // token
        request.setRequestHeader('Authorization', `Bearer ${this.authQuery.access_token}`);

        // Should call the progress method to update the progress to 100% before calling load
        // Setting computable to false switches the loading indicator to infinite mode
        request.upload.onprogress = (e) => {
          progress(e.lengthComputable, e.loaded, e.total);
        };

        // Should call the load method when done and pass the returned server file id
        // this server file id is then used later on when reverting or restoring a file
        // so your server knows which file to return without exposing that info to the client
        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            // the load method accepts either a string (id) or an object
            load(request.responseText);
          } else {
            // Can call the error method if something is wrong, should exit after
            error('oh no');
          }
        };

        request.send(formData);

        // Should expose an abort method so the request can be cancelled
        return {
          abort: () => {
            // This function is entered if the user has tapped the cancel button
            request.abort();

            // Let FilePond know the request has been cancelled
            abort();
          },
        };
      },
      revert: 'filepond/revert',
      restore: 'filepond/restore?id=',
      fetch: 'filepond/fetch?data=',
      load: 'filepond/load',
    },
  };

  pondFiles = [
    // 'index.html'
  ];

  // request vars
  version: string | null = environment.version;
  error: string | undefined;
  isLoading = false;

  frmMandat: FormGroup;
  submitted = false;

  //imageStorage = environment.webstorage + '/';
  imageStorage = environment.serverUrl + '/'; // images gehen über api
  _profile_image = '';

  // tatbestand
  transfer_tatbestande: Tatbestand[];

  // demo image gallery
  items1: GalleryItem[];
  mandatImages: MandatImage[];

  // plate recognition result
  plateRecon: any = '';
  private translateLandPipe = new TranslateLandPipe();

  // Freitext placeholders
  @ViewChild('freitextArea') freitextArea: ElementRef<HTMLTextAreaElement>;
  vstvSettings: Settings | null = null;

  availablePlaceholders = [
    { label: '##Aktenzahl##', value: '##Aktenzahl##', description: 'Aktenzeichen des Mandats' },
    { label: '##Dienstnehmer_Name##', value: '##Dienstnehmer_Name##', description: 'Name des Dienstnehmers' },
    { label: '##Dienst_Nummer##', value: '##Dienst_Nummer##', description: 'Dienstnummer' },
    { label: '##Erfassungsdatum##', value: '##Erfassungsdatum##', description: 'Datum der Erfassung' },
    { label: '##Anmerkungen##', value: '##Anmerkungen##', description: 'Anmerkungen zum Mandat' },
    { label: '##Kennzeichen##', value: '##Kennzeichen##', description: 'KFZ-Kennzeichen (Land Bezirk Nummer)' },
    { label: '##Marke##', value: '##Marke##', description: 'Fahrzeugmarke / Hersteller' },
    { label: '##Hersteller##', value: '##Hersteller##', description: 'Fahrzeughersteller' },
    { label: '##VSTV_Code##', value: '##VSTV_Code##', description: 'VSTV-Code des Tatbestands' },
    { label: '##Paragraph##', value: '##Paragraph##', description: 'Paragraph des Tatbestands' },
    { label: '##Tatdatum_von##', value: '##Tatdatum_von##', description: 'Tatdatum von' },
    { label: '##Tatdatum_bis##', value: '##Tatdatum_bis##', description: 'Tatdatum bis' },
    { label: '##Tatzeit_von##', value: '##Tatzeit_von##', description: 'Tatzeit von' },
    { label: '##Tatzeit_bis##', value: '##Tatzeit_bis##', description: 'Tatzeit bis' },
    { label: '##Anzahl_Fotos##', value: '##Anzahl_Fotos##', description: 'Anzahl der Fotos' },
    { label: '##Strasse##', value: '##Strasse##', description: 'Straße des Tatorts' },
    { label: '##Hausnummer##', value: '##Hausnummer##', description: 'Hausnummer des Tatorts' },
  ];
  // Akt per Mail dialog
  showMailDialog: boolean = false;
  sendingMail: boolean = false;
  mailTo: string = '';
  mailBcc: string = '';
  mailSubject: string = '';
  mailBody: string = '';

  //_country: string = '';

  constructor(
    private element: ElementRef,
    private _fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private _snackBar: MatSnackBar,
    private authService: AuthDataService,
    private authQuery: AuthQuery,
    private router: Router,
    private _activeRoute: ActivatedRoute,
    private journalService: JournalService,
    private cookieService: CookieService,
    private deviceService: DeviceDetectorService,
    private transferService: TransferMandatService,

    private mandatService: MandatService,
    private imageService: ImageService,
    public gallery: Gallery,
    public dialog: MatDialog,
    public dataChangeService: DataChangeMandateService,
    public stammdatenService: StammdatenService,
    private datePipe: DatePipe,
    private navigationListService: NavigationListService,
    private settingsService: SettingsService
  ) {
    console.log('firststart-constructor');

    //this._country = this.authQuery.country;

    // init the form
    this.initForm();
  }

  ngOnInit(): void {
    console.log('firststart-oninit');

    // Load VSTV settings (for VOR/NACH Textbausteine)
    this.settingsService.getSettings().subscribe(
      (s: Settings) => { this.vstvSettings = s; },
      (err) => { console.error('Failed to load settings for Textbausteine', err); }
    );

    // build lightbox gallery
    //this.gallery.ref().load(this.items1);

    this._activeRoute.paramMap.subscribe((paramMap) => {
      this.mandat_id = paramMap.get('id');

      this._uid = paramMap.get('_uid');
      //this._fid = paramMap.get('_fid');
      this._fid = this.mandat_id;
      this._role = paramMap.get('_role');
      //this._country = paramMap.get('_country');
      this._isAdmin = paramMap.get('ia');

      // get the data for the form and the tabs
      this.loadInitData();

      // reset the form
      this.initForm;

      // tatbestand
      this.transfer_tatbestande = [];

      // reset the filepond -> new display
      this.resetFilePond();

      // restet log
      this.pruefung_positiv = 1;
      this.pruefprotokoll = '';
      this.errorprotokoll = '';
    });

    //
    //
    // and also setup a subscriber if any value changes (for example the status)
    //
    this.frmMandat.valueChanges.subscribe((selectedValue) => {
      console.log('status_id changed to:', selectedValue);
    });
  }

  get role(): number | null {
    return this.authQuery.role;
  }

  get isAdmin(): boolean {
    return this.authQuery.isAdmin;
  }

  /** Write actions: Admin/Superuser and only when Demo-Mode is off. */
  get canWrite(): boolean {
    return this.isAdmin && this.authQuery.editingAllowed;
  }

  // --- Prev / Next navigation ---
  get hasPrev(): boolean {
    return this.navigationListService.getPrevMandateId(this.mandat_id) !== null;
  }
  get hasNext(): boolean {
    return this.navigationListService.getNextMandateId(this.mandat_id) !== null;
  }
  get positionLabel(): string {
    return this.navigationListService.getMandatePosition(this.mandat_id);
  }

  navigatePrev() {
    const prevId = this.navigationListService.getPrevMandateId(this.mandat_id);
    if (prevId !== null) {
      this.router.navigate(['/mandate/edit', {
        id: prevId, _uid: prevId, _fid: prevId, _role: this._role, _country: '', ia: this._isAdmin
      }]);
    }
  }

  navigateNext() {
    const nextId = this.navigationListService.getNextMandateId(this.mandat_id);
    if (nextId !== null) {
      this.router.navigate(['/mandate/edit', {
        id: nextId, _uid: nextId, _fid: nextId, _role: this._role, _country: '', ia: this._isAdmin
      }]);
    }
  }

  /**
   * be informed on changeds on the datasource
   * @param data
   */
  broadcastChanges(data: any) {
    console.log('broadcast changes ');
    console.log(data);
    this.dataChangeService.updateData(data);
  }

  /**
   * initialize the form -> reset it
   */
  initForm() {
    // load and init the form
    this.frmMandat = this._fb.group({
      //uid: this.authQuery.userid,
      //fid: this.authQuery.fid,
      //role: this.authQuery.role,
      uid: 0,
      fid: 0,
      role: 3,
      firststart_done: this.authQuery.firststart_done,

      id: '',
      mandat_id: '',

      aktenzeichen: ['', Validators.required],
      land: '',
      bezirk: '',
      nummer: '',
      hersteller: '',
      farbe: '',
      fahrzeugart: '',
      status_id: '0',

      tatzeit: '',
      tat_datum: '',
      tat_zeit: '',
      tatzeit_bis_datum: '',
      tatzeit_bis_uhrzeit: '',

      strasse: '',
      hausnummer: '',
      tatbestandNr: '',
      dienstNr: '',
      dienstNrSTVO: '',
      person: '',

      strafe: '',

      internal_notes: '', // info3
      anmerkungen: '', // notes
      probekennzeichen: 0, // info2
      bom: 0, // 1 = BOM, 0 = Anzeige

      konkretisierung: '', // is a json
      //zusatz1: '',    // nicht mehr benotigt
      //zusatz2: '',    // nicht mehr benotigt

      freitext: '', // Freitext mit Platzhaltern

      tatbestande: this._fb.array([]), // json from tatbestnr

      selection: [],
      colorControl: [],
      makeControl: [],

      allTatbestande: [],
    });
  }

  /**
   * load all the data for the form
   * @returns
   */
  loadInitData() {
    // get both data

    this.stammdatenService
      .getStammdaten()
      .pipe(
        switchMap((response) => {
          this.stammdaten = response.data;

          return this.mandatService.getMandatById(this.mandat_id);
        })
      )
      .subscribe(
        (rdata: MandatSingle) => {
          console.log('visitor from DB');
          console.log(rdata);

          this.mandat = rdata.data;

          // merge the data for the luecken table
          this.transfer_tatbestande = this.mergeDataTatbestande(
            this.stammdaten.tatbestande,
            rdata.data.Md_TatbestNr,
            rdata.data.Md_Konkretisierung
          );

          // ------------------------------ transfer
          //
          // set the profile image
          this._profile_image = ''; //visitor.data.profile_image;

          // set the accounting link
          //this._accounting_link = environment.serverUrl + '/pdf-accinfo/' + this._fid + '?&akey=12987361235283447283261';

          this.aktenzeichen = this.mandat.Md_BelegNr;

          this.frmMandat.patchValue({
            uid: this._uid,
            fid: this._fid,
            role: this._role,
            //firststart_done: this.authQuery.firststart_done,

            id: this.mandat.Md_PrimKey,
            mandat_id: this.mandat.Md_PrimKey,

            aktenzeichen: this.mandat.Md_BelegNr,
            land: this.mandat.Md_KzLand,
            bezirk: this.mandat.Md_KzBezirk,
            nummer: this.mandat.Md_KzNummer,
            hersteller: this.mandat.Md_Hersteller,
            farbe: this.mandat.Md_Farbe.toLowerCase(),
            probekennzeichen: +this.mandat.info2 === 1 ? 1 : 0, // BUG BUG BUG not imploemented yet

            status_id: this.mandat.Md_Status ?? '0',

            fahrzeugart: this.mandat.fahrzeugart,

            tat_datum: this.mandat.Md_Datum,
            tat_zeit: this.mandat.Md_ZeitVon,
            tatzeit: this.mandat.Md_ZeitBis,
            tatzeit_bis_datum: this.mandat.tatzeit_bis_datum || '',
            tatzeit_bis_uhrzeit: this.mandat.tatzeit_bis_uhrzeit || '',

            strasse: this.mandat.Md_Strasse,
            hausnummer: this.mandat.Md_HausNr,
            tatbestandNr: this.mandat.Md_TatbestNr,
            dienstNr: this.mandat.Md_DienstNr,
            dienstNrSTVO: this.mandat.dienstnr_stvo,
            person: this.mandat.person,
            konkretisierung: this.mandat.Md_Konkretisierung,

            //zusatz1: this.mandat.zusatz1,
            //zusatz2: this.mandat.zusatz2,

            strafe: this.mandat.strafe,

            anmerkungen: this.mandat.notes, // anmerkungen
            internal_notes: this.mandat.interne_notes, // internal_notes
            bom: this.mandat.bom ?? 0, // 1 = BOM, 0 = Anzeige

            freitext: this.mandat.freitext || '',

            tatbestande: [],

            selection: [],
            colorControl: [],
            makeControl: [],
            allTatbestande: [],
          });
          // and now add the dynamic form controls for luecken

          // reset the formarray
          const formArray = this.frmMandat.get('tatbestande') as FormArray;
          formArray.clear();

          // and now fill it with the correct luecken
          this.transfer_tatbestande.forEach((tatbestand) => {
            const tatbestandGroup = this._fb.group({
              luecken: this._fb.array(
                tatbestand.luecken.map((luecke) => this._fb.control(luecke.value || luecke.default))
              ),
            });
            this.tatbestandeFormArray.push(tatbestandGroup);
          });

          // show me the result
          console.log('------------------ merge patch values form ---_');
          console.log(this.frmMandat.value);

          // build the tatbestand object for the table-visualization
          // this.get_Tatbestande_with_Luecken(this.transfer.tatbestnr);

          // get all journal-items with that $aktenzeichen
          this.getAllJournalItems(this.mandat_id, this.mandat.Md_BelegNr);

          // load the images from the giveen transfer-mandat
          //this.items1 = imageData1.map((item) => new ImageItem({ src: item.srcUrl, thumb: item.previewUrl }));
          let searchterm = '';
          let aktenzeichen = this.mandat.Md_BelegNr;
          this.imageService
            .getImages(
              //pageNumber = 1,
              //pageSize = 100,
              //sort = '',
              //order = null,
              searchterm,
              //filtersArgs: string,
              aktenzeichen
            )
            .subscribe((res: MandatImageTable) => {
              this.mandatImages = res.data;
              this.cdr.detectChanges();

              // load the exifdata for each image
              this.loadExifImageData();
            });
        },
        (error) => {
          console.error('Error during sequential API calls:', error);
        }
      );

    // ------------------------------ stammdaten
    // filter the bezirke
    // based on the land value
    this.filteredBezirke$ = this.frmMandat.controls['land'].valueChanges.pipe(
      startWith(''),
      map((land) => this.stammdaten.bezirke.filter((b) => b.land === land))
    );
  }

  //
  // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  //

  //
  // --------------------- TATBESTANDE
  //

  get tatbestandeFormArray(): FormArray {
    return this.frmMandat.get('tatbestande') as FormArray;
  }

  /**
   * merge the given data into the full tatbestande infos -> stammdaten + values luecken
   * @param stammdaten
   * @param specificData
   * @returns
   */
  mergeDataTatbestande(stammdatenTatbestande, tatbestande, luecken_values_json): Tatbestand[] {
    // Clone the original stammdaten to avoid mutations
    let cloneStammdaten = [];
    try {
      cloneStammdaten = JSON.parse(JSON.stringify(stammdatenTatbestande));
    } catch (error) {
      console.error('Failed to parse cloneStammdaten:', error);
      cloneStammdaten = [];
    }

    let transferTatbestande = [];
    try {
      transferTatbestande = JSON.parse(tatbestande);
    } catch (error) {
      console.error('Failed to parse transferTatbestande:', error);
      transferTatbestande = [];
    }

    let luecken_values: LueckenValue[] = [];
    try {
      luecken_values = luecken_values_json ? JSON.parse(luecken_values_json) : [];
    } catch (error) {
      console.error('Failed to parse luecken_values_json:', error);
      luecken_values = [];
    }

    if (!Array.isArray(transferTatbestande)) {
      transferTatbestande = [];
    }

    // Determine the version of originalCodes
    const codesMap = new Map<string, { luecke: number; value?: string }[]>();
    if (transferTatbestande.length > 0 && typeof transferTatbestande[0] === 'string') {
      // old versaion
      console.log("It's the old version");
      //return []; // Return early or handle as needed
      // Mapping original codes for quick lookup

      (transferTatbestande as Tatbestand[]).forEach((code) => {
        codesMap.set('' + code, []);
      });
    } else {
      // new version
      // Mapping original codes for quick lookup
      (transferTatbestande as Tatbestand[]).forEach((code) => {
        codesMap.set('' + code.id, code.luecken);
      });
    }

    // Enrich stammdaten with values from originalCodes
    const enrichedTatbestande: Tatbestand[] = cloneStammdaten
      .filter(
        (tatbestand: Tatbestand) => codesMap.has(tatbestand.vstv_code) // Only include tatbestande that have corresponding codes
      )
      .map((tatbestand: Tatbestand) => {
        const matchedCodes = codesMap.get(tatbestand.vstv_code);

        if (!Array.isArray(tatbestand.luecken)) {
          tatbestand.luecken = [];
        }

        if (matchedCodes) {
          tatbestand.luecken = tatbestand.luecken.map((luecke) => {
            const matchedLuecke = matchedCodes.find((c) => c.luecke === luecke.luecke);
            if (matchedLuecke) {
              return { ...luecke, value: matchedLuecke.value };
            }
            return luecke;
          });
        }
        return tatbestand;
      });

    // and now fill it with the given values
    enrichedTatbestande.forEach((tatbestand, index) => {
      const konkretisierungItem: LueckenValue = luecken_values[index];
      if (tatbestand.luecken && konkretisierungItem?.luecken) {
        tatbestand.luecken.forEach((luecke, lueckeIndex) => {
          if (konkretisierungItem.luecken.length > lueckeIndex) {
            // Check if the value exists
            luecke.value = konkretisierungItem.luecken[lueckeIndex] || luecke.default; // Use default if konkretisierung value is empty
          }
        });
      }
    });

    return enrichedTatbestande;
  }

  // how the luecken should be tracked in the for loop
  trackByFn(index, tatbestand: Tatbestand) {
    return tatbestand.id;
  }

  newTatbestand: string;
  addTatbestand() {
    const vstv_code = this.frmMandat.controls['allTatbestande'].value;
    console.log('add tatbestand ' + vstv_code);

    // Find the matching tatbestand
    const matchingTatbestand = this.stammdaten.tatbestande.find((tatbestand) => tatbestand.vstv_code === vstv_code);

    if (!matchingTatbestand) {
      //console.error('No matching tatbestand found');

      this._snackBar.open('Bitte wählen Sie einen Tatbestand in der Liste aus.', 'Schließen', {
        duration: 1000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
    } else {
      // add the selected tatbestand to the list
      this.transfer_tatbestande.push(matchingTatbestand);

      // and push it also into the frmMandat form
      // and now fill it with the correct luecken
      // wir müssen nur die luecken hinzufuegen -> rest kommt aus tranfer_tatbestand

      const tatbestandGroup = this._fb.group({
        luecken: this._fb.array(
          matchingTatbestand.luecken.map((luecke) => this._fb.control(luecke.value || luecke.default))
        ),
      });
      this.tatbestandeFormArray.push(tatbestandGroup);

      let arTaten: string[] = [];
      this.transfer_tatbestande.forEach((tatbestand) => {
        arTaten.push(tatbestand.vstv_code);
      });
      // also update the form-field tatbestandnr (json of all selected vstv_codes)
      this.frmMandat.patchValue({
        tatbestandNr: JSON.stringify(arTaten),
      });
    }
  }

  removeTatbestand(index: number, vstv_code: number) {
    console.log('remove  tatbestand');

    // get the confirmation
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'custom-dialog-container',
      data: {
        title: 'Bestätigung',
        message: 'Der ausgewählte Tatbestand wird gelöscht.',
        cancelButton: 'Abbrechen',
        confirmButton: 'Ok',
      },
      width: '450px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        // ok was clicked
        console.log('tatbestand löschen');

        // remove it from the array
        this.transfer_tatbestande.splice(index, 1);

        // remove it from the luecken formarray
        this.tatbestandeFormArray.removeAt(index);

        // remove it from the tatbestandnr array
        let tatbestandNr = this.frmMandat.get('tatbestandNr')?.value;
        let arTatbestandNr = JSON.parse(tatbestandNr);

        //arTatbestandNr.splice(index, 1); --> not working as index changes
        arTatbestandNr = arTatbestandNr.filter((item) => item !== vstv_code);

        this.frmMandat.patchValue({
          tatbestandNr: JSON.stringify(arTatbestandNr),
        });
      } else {
        // cancel
      }
    });
  }

  //
  // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  //

  //
  // --------------------- JOURNAL
  //

  /**
   * get all journal entries for the given aktenzahl
   */
  getAllJournalItems(transfer_id: string, aktenzeichen: string) {
    // the parameters
    const dataIn = {
      tid: transfer_id,
      aktenzeichen: aktenzeichen,
    };

    this.journalService.getItemsByParams(dataIn).subscribe(
      (result: any) => {
        console.log(result);
        this.journalItems = result.data;
      },
      (error) => {
        console.error('Failed to fetch items:', error);
      }
    );
  }

  /**
   * map a journal category to a tailwind color badge
   */
  journalCategoryClass(category: string): string {
    switch ((category || '').toUpperCase()) {
      case 'TRANSFER':
        return 'bg-blue-100 text-blue-800';
      case 'MANDAT':
        return 'bg-green-100 text-green-800';
      case 'VSTV':
      case 'VSTV25':
        return 'bg-purple-100 text-purple-800';
      case 'CHECK':
        return 'bg-orange-100 text-orange-800';
      case 'ZAHLUNG':
        return 'bg-yellow-100 text-yellow-800';
      case 'AUTH':
        return 'bg-gray-200 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  }

  /**
   * pretty-print the journal info field (JSON if possible, otherwise raw text)
   */
  formatJournalInfo(info: any): string {
    if (info === null || info === undefined || info === '') {
      return '';
    }
    try {
      const parsed = typeof info === 'string' ? JSON.parse(info) : info;
      return JSON.stringify(parsed, null, 2);
    } catch (e) {
      return '' + info;
    }
  }

  //
  // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  //

  //
  // --------------------- FILEUPLOAD
  //

  //
  // --------------------- FILEUPLOAD
  //

  pondHandleInit() {
    console.log('FilePond has initialised', this.myPond);
  }

  pondHandleAddFile(event: any) {
    console.log('A file was added', event);

    // get the name of the upload object
    let elementId = event.pond.id.get();

    console.log(event.pond.files.get());

    // data-maxnumber should store the max numbers of file that are allowed to upload
    //return false;
  }

  // clear the upload pond after all files are processed
  onProcessFiles(event: any) {
    if (event.error) {
      console.error('Error during processing:', event.error);
    } else {
      console.log('All files processed successfully');
      event.pond.removeFiles();

      // get all the images again
      const searchterm = '';
      this.imageService.getImages(searchterm, this.aktenzeichen).subscribe((res: MandatImageTable) => {
        this.mandatImages = res.data;
      });
    }
  }

  pondHandleActivateFile(event: any) {
    console.log('A file was activated', event);
  }

  // reset the filepond
  resetFilePond() {
    if (this.myPond) {
      // Ensure FilePond is fully initialized before attempting to interact with it
      setTimeout(() => this.myPond.pond.removeAllFiles(), 0);
    }
  }

  //
  // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  //

  //
  // ---------------------
  //

  /**
   *
   * save the transfer with status DRAFT
   */

  saveStatusChange(newStatus: StatusMandat) {
    console.log('change status draft');
    // console.log(this.frmMandat.value);

    this.updateTatbestandNr(); // update also the tatbestand info

    // update to the server
    this.mandatService.changeStatus(<Mandat>this.frmMandat.value, newStatus).subscribe(
      (response: any) => {
        //next() callback
        console.log('response received');
        console.log(response);

        // update the form
        this.frmMandat.patchValue({
          //id: response.id,
          status_id: response.status_id,
        });
        this.mandat.Md_Status = response.status_id;

        this.cdr.detectChanges();

        // broadcast the changes back to the table-view
        this.broadcastChanges(response);

        // refresh the journal timeline so the status-change entry appears
        this.getAllJournalItems(this.mandat_id, this.mandat.Md_BelegNr);

        this._snackBar.open('Status wurde erfolgreich verändert', 'Close', {
          duration: 1000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });

        //
        // show some feedback --> snackbar ?
        //
      },
      (error) => {
        //error() callback
        console.error('Request failed with error');
        //this.errorMessage = error;
      },
      () => {
        //complete() callback
        console.log('Request completed'); //This is actually not needed
      }
    );
  }

  /**
   *
   * manuel check if the TRANSFER is valid for migration to MANDAT
   */
  pruefung_positiv: number = 1;
  pruefprotokoll: string = '';
  errorprotokoll: string = '';
  checkMandat() {
    // tempory save -> firststart daten
    // bei step change
    console.log('check everything first');

    this.updateTatbestandNr();

    // update to the server
    this.mandatService.checkMandat(this.frmMandat.value).subscribe(
      (response: any) => {
        //next() callback
        console.log('response received');
        console.log(response);

        // get log
        this.pruefung_positiv = response.positiv;
        this.pruefprotokoll = response.log;
        this.errorprotokoll = response.errorLog;

        // refresh the journal timeline so the check entry appears
        this.getAllJournalItems(this.mandat_id, this.mandat.Md_BelegNr);

        // was the check positiv
        if (response.positiv == 1) {
          // yes the check was positiv
          // transfer can be migrated to mandat
          // update the form
          /*
        this.frmMandat.patchValue({
          status_id: '1',
        });
        this.mandat.Md_Status = "1";
        this.cdr.detectChanges();

        // broadcast the changes back to the table-view
        this.broadcastChanges(response.mandat);
        */

          this._snackBar.open('Prüfung positiv', 'Schließen', {
            duration: 1000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        } else {
          // no there was an error
          // update the form
          this.frmMandat.patchValue({
            status_id: '9',
          });
          this.mandat.Md_Status = '9';
          this.cdr.detectChanges();

          // broadcast the changes back to the table-view
          this.broadcastChanges(response.mandat);

          this._snackBar.open('Prüfung negativ - Fehler', 'Schließen', {
            duration: 1000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }
      },
      (error) => {
        //error() callback
        console.error('Request failed with error');
        //this.errorMessage = error;
      },
      () => {
        //complete() callback
        console.log('Request completed'); //This is actually not needed
      }
    );
  }

  // update the tatbestandnummer with the luecken value informations
  updateTatbestandNr() {
    /*

      wir machen das jetzt nicht mehr so
      sondern anders -> wir speichern das ganze auf der php server seite
      hier wird eine extra info übergeben => tatbestande -> array mit lücken


    // save the tatbestande and the luecken information
    const transformedData = this.transfer_tatbestande.map((item) => ({
      vstv_code: item.vstv_code,
      luecken_values: item.luecken.map((luecke) => luecke.value),
    }));

    this.frmMandat.patchValue({
      tatbestandNr: JSON.stringify(transformedData),
    });
    */

    // in der neuen version
    // werden die luecken einfach in der konkretisierung gespeichert
    let tatbestandeInfo = this.frmMandat.get('tatbestande')?.value;

    this.frmMandat.patchValue({
      konkretisierung: tatbestandeInfo,
    });
  }

  /**
   *
   *
   */
  plateReconResults = [];
  plateReconFull: any = null;
  recognizePlate(filename: string) {
    console.log('file' + filename);
    this.imageService.recognizeImage(filename).subscribe((res: any) => {
      console.log(res);

      // keep the full plate recognizer response so we can persist it later
      this.plateReconFull = res;

      //check if plate recon was successful
      if (res.results.length == 0) {
        this._snackBar.open('Kennzeichen konnte nicht ermittelt werden.', 'Schließen', {
          horizontalPosition: 'center',
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snackbar-ontop',
        });
      } else {
        this.plateReconResults = res.results;

        //alert('dieser code ist noch alt');
        // er nimmt die : getSelectedResult

        this.plateRecon = res.results[0] ?? [];

        //this.modell = this.plateRecon.model_make[0] ?? [];
        //this.farbe = this.plateRecon.color[0] ?? [];
        //this.richtung = this.plateRecon.orientation[0] ?? [];

        this._snackBar.open('Kennzeichen wurde ermittelt. Ergebnis kann ausgewählt werden.', 'Schließen', {
          horizontalPosition: 'center',
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snackbar-ontop',
        });
      }

      // get the values
    });
  }

  getSelectedResult(): any | string | undefined {
    return this.plateReconResults[this.frmMandat.get('selection')?.value] || null;
  }

  /**
   * District codes (Bezirkskennzeichen) the client actually uses (usage == 1),
   * passed to the plate badge so the plate split is deterministic for this client.
   */
  get activeBezirkeCodes(): string[] {
    const list: any[] = (this.stammdaten as any)?.bezirke ?? [];
    return list
      .filter((b: any) => (b?.usage ?? 1) === 1)
      .filter((b: any) => !b?.land || ('' + b.land).toUpperCase().trim() === 'A')
      .map((b: any) => ('' + (b?.bezeichnung ?? '')).toUpperCase().trim())
      .filter((c: string) => c.length > 0);
  }

  /**
   * Filename (as stored in tbl_images) of the image the recognition ran on.
   * Plate Recognizer's own "filename" is its internal name and does NOT exist
   * in our storage, so we derive the real file from camera_id.
   */
  get anprSourceFilename(): string | null {
    const parsed = this.parseAnprJson();
    const cameraId = parsed?.camera_id;
    if (typeof cameraId === 'string' && cameraId.length > 0) {
      const pathPart = cameraId.split(' - ').pop() ?? cameraId;
      const base = pathPart.split(/[\\/]/).pop();
      if (base && base.trim().length > 0) {
        return base.trim();
      }
    }
    return parsed?.filename ?? null;
  }

  private parseAnprJson(): any | null {
    const raw = this.mandat?.anpr_json;
    if (!raw) {
      return null;
    }
    try {
      return typeof raw === 'string' ? JSON.parse(raw) : raw;
    } catch {
      return null;
    }
  }

  /**
   * Style object for the green rectangle drawn over the selected/active plate on
   * the main image. Coordinates are expressed as percentages of the recognition
   * image size, so the overlay scales with the responsive <img>.
   *
   * Returns null when there is no ANPR data, or when the currently displayed main
   * image is not the image the recognition actually ran on (avoids a misplaced box).
   */
  getSelectedAnprBoxStyle(): { [k: string]: string } | null {
    const parsed = this.parseAnprJson();
    const results = parsed?.results;
    if (!Array.isArray(results) || results.length === 0) {
      return null;
    }

    // only draw on the image the recognition was performed on
    const mainImage = this.mandatImages?.[0]?.filename;
    if (!mainImage || mainImage !== this.anprSourceFilename) {
      return null;
    }

    // prefer the live selection (pulldown), fall back to the stored index
    let idx = Number(this.frmMandat?.get('selection')?.value);
    if (!Number.isInteger(idx) || idx < 0 || idx >= results.length) {
      idx = Number(this.mandat?.anpr_selected_index);
    }
    if (!Number.isInteger(idx) || idx < 0 || idx >= results.length) {
      idx = 0;
    }

    const box = results[idx]?.box;
    const w = Number(parsed?.image_width);
    const h = Number(parsed?.image_height);
    if (!box || !w || !h) {
      return null;
    }

    const left = (box.xmin / w) * 100;
    const top = (box.ymin / h) * 100;
    const width = ((box.xmax - box.xmin) / w) * 100;
    const height = ((box.ymax - box.ymin) / h) * 100;

    return {
      position: 'absolute',
      left: left + '%',
      top: top + '%',
      width: width + '%',
      height: height + '%',
      border: '3px solid #00c853',
      'border-radius': '2px',
      'box-sizing': 'border-box',
      'pointer-events': 'none',
      'box-shadow': '0 0 0 1px rgba(0,0,0,0.35)',
    };
  }

  // when the treffer pulldown was changed
  onTrefferChange(event) {
    console.log('Selected value: ', event.value);

    /*      selection: [],
       colorControl: [],
       makeControl: [],*/
    /*
     this.frmMandat.get('colorControl')?.setValue("");

     if (this.frmMandat.get('selection').length > 0) {
       this.selectControl.setValue(this.items[0].value);
     }
     */
  }

  /**
   * input default text fuer abmahnung
   */
  abmahnung() {
    // set the default text
    this.frmMandat.patchValue({
      internal_notes: 'Abmahnung per VSTG §50(5a)',
    });
  }

  /**
   * speichern der plate erkennung
   *
   *
   */
  savePlateRecon() {
    console.log('save palte recon');

    // get the data from the selected anpr
    //this.modell = this.plateRecon.model_make[0] ?? [];
    //this.farbe = this.plateRecon.color[0] ?? [];
    //this.richtung = this.plateRecon.orientation[0] ?? [];

    let plateRecon: PlateRecon = {
      id: this.mandat.Md_PrimKey,
      aktenzeichen: this.aktenzeichen,

      land: '' + this.translateLandPipe.transform(this.getSelectedResult().region.code).toUpperCase(),
      bezirk: '' + (this.frmMandat.get('bezirk')?.value ?? ''),

      kennzeichen: '' + this.getSelectedResult()?.plate?.toUpperCase(),
      plate: '' + this.getSelectedResult()?.plate?.toUpperCase(),

      farbe: this.frmMandat.get('colorControl')?.value ?? '',
      hersteller: this.frmMandat.get('makeControl')?.value ?? '',
      notes: '' + (this.frmMandat.get('internal_notes')?.value ?? ''),

      anpr_json: this.plateReconFull ? JSON.stringify(this.plateReconFull) : '',
      anpr_selected_index: Number(this.frmMandat.get('selection')?.value ?? 0),
      entity: 'mandate',
    };

    this.transferService.savePlateRecognition(plateRecon).subscribe({
      next: (response) => {
        // update form with the correct data
        //this.frmMandat.patchValue(response);

        this.frmMandat.patchValue({
          land: '' + this.translateLandPipe.transform(this.getSelectedResult().region.code).toUpperCase(),
          nummer: this.getSelectedResult()?.plate?.toUpperCase(),
          hersteller: this.frmMandat.get('makeControl')?.value ?? '',
          farbe: this.frmMandat.get('colorControl')?.value ?? '',
        });
        this.cdr.detectChanges(); // update gui
        this.broadcastChanges(response); // update table

        // console.log('Server response:', response);
        this._snackBar.open('Kennzeichen-Erkennung erfolgreich übertragen', 'Schließen', {
          duration: 1000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      },
      error: (error) => {
        console.error('Error:', error);
        this._snackBar.open('Bei der Speicherung trat ein Fehler auf. #43a', 'Schließen', {
          duration: 1000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      },
    });
  }

  /**
   * DELETE the TRANSFER
   *
   *
   */
  removeTransfer() {
    // get the confirmation
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'custom-dialog-container',
      data: {
        title: 'Bestätigung',
        message: 'Der ausgewählte Eintrag wird gelöscht.',
        cancelButton: 'Abbrechen',
        confirmButton: 'Ok',
      },
      width: '450px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        // ok was clicked
        console.log(result);

        //
        // in our case -> we do no DELETE
        // we change the status auf UNGULTIG
        //

        var new_status = StatusTransfer.UNGULTIG;

        // update to the server
        this.transferService.changeStatus(<TransferMandat>this.frmMandat.value, new_status).subscribe(
          (response: any) => {
            //next() callback
            console.log('response received');
            console.log(response);

            // update the form
            this.frmMandat.patchValue({
              status_id: '3',
            });
            this.cdr.detectChanges();
            console.log(this.frmMandat.value);

            // broadcast the changes back to the table-view
            this.broadcastChanges(response);

            this._snackBar.open('Datensatz erfolgreich gelöscht.', 'Close', {
              duration: 1000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });

            //
            // show some feedback --> snackbar ?
            //
          },
          (error) => {
            //error() callback
            console.error('Request failed with error');
            //this.errorMessage = error;
          },
          () => {
            //complete() callback
            console.log('Request completed'); //This is actually not needed
          }
        );

        //
        this.closeOffcanvas();
      } else {
        // cancel
      }
    });
  }

  /**
   * Open image in an in-app lightbox with download.
   */
  openImageInNewWindow(imageSrc: string): void {
    const filename = (imageSrc || '').split('/').pop() || 'image.jpg';
    this.dialog.open(ImageLightboxComponent, {
      data: {
        imageUrl: `${this.imageStorage}img?f=${imageSrc}`,
        filename,
      },
      panelClass: 'image-lightbox-panel',
      backdropClass: 'image-lightbox-backdrop',
      maxWidth: '95vw',
      maxHeight: '95vh',
      autoFocus: false,
    });
  }

  /**
   * Confirm and delete an image (DB record only, file stays on server)
   */
  confirmDeleteImage(img: any): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Bild löschen?',
        message:
          'Sind Sie sicher, dass dieses Bild entfernt werden soll? Dieser Vorgang kann nicht rückgängig gemacht werden.',
        confirmText: 'Löschen',
        cancelText: 'Abbrechen',
      },
      width: '450px',
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.imageService.deleteImage(img.id).subscribe({
          next: (res: any) => {
            if (res.result === 1) {
              this.mandatImages = this.mandatImages.filter((i: any) => i.id !== img.id);
              this.cdr.detectChanges();
              // refresh the journal timeline so the image-delete entry appears
              this.getAllJournalItems(this.mandat_id, this.mandat.Md_BelegNr);
              this._snackBar.open('Bild erfolgreich gelöscht.', 'Schließen', {
                duration: 3000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
              });
            } else {
              this._snackBar.open(res.error || 'Fehler beim Löschen.', 'Schließen', {
                duration: 3000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
              });
            }
          },
          error: () => {
            this._snackBar.open('Fehler beim Löschen des Bildes.', 'Schließen', {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
          },
        });
      }
    });
  }

  /**
   * close the offcanvas
   */
  closeOffcanvas() {
    const offcanvasElement = document.getElementById('staticBackdrop');
    const offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvasElement);
    if (offcanvasInstance) {
      offcanvasInstance.hide();
    }
  }

  /**
   * Open the "Akt per Mail senden" dialog.
   * Pre-fills fields from settings defaults and resolves placeholders.
   */
  sendPerMail() {
    // Load settings to get defaults
    this.settingsService.getSettings().subscribe(
      (settings: Settings) => {
        this.mailTo = settings.MAIL_DEFAULT_TO || '';
        this.mailBcc = settings.MAIL_DEFAULT_BCC || '';
        this.mailSubject = this.resolveMailPlaceholders(settings.MAIL_DEFAULT_SUBJECT || '');
        this.mailBody = this.resolveMailPlaceholders(settings.MAIL_DEFAULT_BODY || '');
        this.showMailDialog = true;
      },
      (error) => {
        console.error('Failed to load mail settings', error);
        // Open dialog anyway with empty defaults
        this.mailTo = '';
        this.mailBcc = '';
        this.mailSubject = '';
        this.mailBody = '';
        this.showMailDialog = true;
      }
    );
  }

  /**
   * Resolve ##...## placeholders in a template string using current mandate data
   */
  private resolveMailPlaceholders(template: string): string {
    if (!template) return '';
    const f = this.frmMandat.value;
    const kennzeichen = [f.land, f.bezirk, f.nummer].filter(Boolean).join(' ');
    const fotoCount = this.mandatImages ? this.mandatImages.length : 0;

    let result = template;
    result = result.replace(/##Aktenzahl##/g, f.aktenzeichen || '');
    result = result.replace(/##Dienstnehmer_Name##/g, f.person || '');
    result = result.replace(/##Dienst_Nummer##/g, f.dienstNr || '');
    result = result.replace(/##Erfassungsdatum##/g, f.tat_datum || '');
    result = result.replace(/##Anmerkungen##/g, f.anmerkungen || '');
    result = result.replace(/##Kennzeichen##/g, kennzeichen);
    result = result.replace(/##Marke##/g, f.hersteller || '');
    result = result.replace(/##Hersteller##/g, f.hersteller || '');
    result = result.replace(/##Tatdatum_von##/g, f.tat_datum || '');
    result = result.replace(/##Tatdatum_bis##/g, f.tatzeit_bis_datum || '');
    result = result.replace(/##Tatzeit_von##/g, f.tat_zeit || '');
    result = result.replace(/##Tatzeit_bis##/g, f.tatzeit_bis_uhrzeit || '');
    result = result.replace(/##Anzahl_Fotos##/g, String(fotoCount));
    result = result.replace(/##Strasse##/g, f.strasse || '');
    result = result.replace(/##Hausnummer##/g, f.hausnummer || '');
    return result;
  }

  /**
   * Close the mail dialog (preserves entered text if called from X button)
   */
  closeMailDialog() {
    this.showMailDialog = false;
  }

  /**
   * Send the email via API
   */
  confirmSendMail() {
    if (!this.mailTo) {
      this._snackBar.open('Bitte eine Empfänger-Adresse eingeben.', 'Schließen', {
        horizontalPosition: 'center', verticalPosition: 'top', duration: 3000,
      });
      return;
    }

    this.sendingMail = true;

    // Build image links
    const imageLinks: string[] = [];
    if (this.mandatImages && this.mandatImages.length > 0) {
      this.mandatImages.forEach((img) => {
        imageLinks.push(this.imageStorage + 'img?f=' + img.filename);
      });
    }

    const payload = {
      to: this.mailTo,
      bcc: this.mailBcc,
      subject: this.mailSubject,
      body: this.mailBody,
      image_links: imageLinks,
      aktenzeichen: this.frmMandat.value.aktenzeichen || '',
    };

    this.settingsService.sendAktMail(payload).subscribe(
      (res: any) => {
        this.sendingMail = false;
        if (res.result === 1) {
          this._snackBar.open('E-Mail erfolgreich gesendet!', 'Schließen', {
            horizontalPosition: 'center', verticalPosition: 'top', duration: 4000,
            panelClass: 'awesome-snackbar',
          });
          this.showMailDialog = false;
        } else {
          this._snackBar.open('Fehler: ' + (res.error || 'Unbekannter Fehler'), 'Schließen', {
            horizontalPosition: 'center', verticalPosition: 'top', duration: 5000,
          });
          // Dialog stays open so user doesn't lose text
        }
      },
      (error) => {
        this.sendingMail = false;
        console.error('Mail send error', error);
        this._snackBar.open('Fehler beim Senden der E-Mail.', 'Schließen', {
          horizontalPosition: 'center', verticalPosition: 'top', duration: 5000,
        });
        // Dialog stays open so user doesn't lose text
      }
    );
  }

  //
  // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  //

  exifDataMap = new Map<string, any>();
  loadExifImageData() {
    // load data via service
    this.mandatImages.forEach((img) => {
      this.imageService.getExifImageData(img.filename).subscribe((res: any) => {
        console.log(res);

        this.exifDataMap.set(img.filename, res.exif);
      });
    });
  }

  // get theexifimagedata
  getExifData(filename: string): string {
    try {
      return this.exifDataMap.get(filename);
    } catch (error) {
      return '';
    }
  }

  // set the tatzeit form the image
  fetchTatzeitFromImage() {
    // fetch from the 1st image

    let imageZeit = this.getExifData(this.mandatImages[0].filename);
    // now set the image tatzeit information
    console.log(imageZeit);

    const [datePart, timePart] = imageZeit.split(' ');
    const [year, month, day] = datePart.split(':').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);

    const dateObject = new Date(year, month - 1, day, hours, minutes, seconds);

    const dateOnly = this.datePipe.transform(dateObject, 'dd.MM.yyyy');
    const timeOnly = this.datePipe.transform(dateObject, 'HH:mm');
    const fullDateTime = `${dateOnly} ${timeOnly}`;

    // update the tatzeit
    this.frmMandat.patchValue({
      tatzeit: fullDateTime,
      tat_datum: dateOnly,
      tat_zeit: timeOnly,
    });
  }

  //
  // --------------------- FREITEXT
  //

  /**
   * Collect drucktext from all VSTV codes on this mandate and append to the freitext textarea
   */
  applyDrucktexte() {
    if (!this.transfer_tatbestande || this.transfer_tatbestande.length === 0) {
      this._snackBar.open('Keine Texte in Stammdaten verfügbar', 'Schließen', {
        horizontalPosition: 'center',
        verticalPosition: 'top',
        duration: 3000,
      });
      return;
    }

    // Collect freitext from each tatbestand, include vstv_code + paragraph as header
    const texte = this.transfer_tatbestande
      .map((tb) => {
        const freitext = (tb.freitext || '').trim();
        if (!freitext) return '';
        const header = [tb.vstv_code, tb.paragraph].filter(v => v && v.trim()).join(' — ');
        return header ? header + '\n' + freitext : freitext;
      })
      .filter((text) => text.length > 0);

    if (texte.length === 0) {
      this._snackBar.open('Keine Texte in Stammdaten verfügbar', 'Schließen', {
        horizontalPosition: 'center',
        verticalPosition: 'top',
        duration: 3000,
      });
      return;
    }

    // Build combined text with VOR/NACH Textbausteine from settings
    const vorText = ((this.vstvSettings as any)?.VOR_TEXTBAUSTEIN || '').trim();
    const nachText = ((this.vstvSettings as any)?.NACH_TEXTBAUSTEIN || '').trim();
    const tatbestandeText = texte.join('\n\n');

    const parts: string[] = [];
    if (vorText) parts.push(vorText);
    parts.push(tatbestandeText);
    if (nachText) parts.push(nachText);

    const combined = parts.join('\n\n');
    const current = this.frmMandat.get('freitext')?.value || '';

    // Append with blank line separator if there is existing text
    const newValue = current
      ? current.trimEnd() + '\n\n' + combined
      : combined;

    this.frmMandat.patchValue({ freitext: newValue });
  }

  /**
   * Insert a placeholder string at the current cursor position in the freitext textarea
   */
  insertFreitextPlaceholder(placeholder: string) {
    const textarea = this.freitextArea?.nativeElement;
    if (!textarea) {
      // Fallback: just append
      const current = this.frmMandat.get('freitext')?.value || '';
      this.frmMandat.patchValue({ freitext: current + placeholder });
      return;
    }

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const currentValue = this.frmMandat.get('freitext')?.value || '';
    const newValue = currentValue.substring(0, start) + placeholder + currentValue.substring(end);
    this.frmMandat.patchValue({ freitext: newValue });

    // Restore cursor position after the inserted placeholder
    setTimeout(() => {
      textarea.focus();
      const newPos = start + placeholder.length;
      textarea.setSelectionRange(newPos, newPos);
    }, 0);
  }

  /**
   * Resolve all ##...## placeholders in the freitext with actual mandate field values
   */
  get freitextPreview(): string {
    const freitext = this.frmMandat?.get('freitext')?.value || '';
    if (!freitext) return '';

    const f = this.frmMandat.value;
    const kennzeichen = [f.land, f.bezirk, f.nummer].filter(Boolean).join(' ');
    const fotoCount = this.mandatImages ? this.mandatImages.length : 0;

    let result = freitext;
    result = result.replace(/##Aktenzahl##/g, f.aktenzeichen || '');
    result = result.replace(/##Dienstnehmer_Name##/g, f.person || '');
    result = result.replace(/##Dienst_Nummer##/g, f.dienstNr || '');
    result = result.replace(/##Erfassungsdatum##/g, f.tat_datum || '');
    result = result.replace(/##Anmerkungen##/g, f.anmerkungen || '');
    result = result.replace(/##Kennzeichen##/g, kennzeichen);
    result = result.replace(/##Marke##/g, f.hersteller || '');
    result = result.replace(/##Hersteller##/g, f.hersteller || '');
    result = result.replace(/##Tatdatum_von##/g, f.tat_datum || '');
    result = result.replace(/##Tatdatum_bis##/g, f.tatzeit_bis_datum || '');
    result = result.replace(/##Tatzeit_von##/g, f.tat_zeit || '');
    result = result.replace(/##Tatzeit_bis##/g, f.tatzeit_bis_uhrzeit || '');
    result = result.replace(/##Anzahl_Fotos##/g, String(fotoCount));
    result = result.replace(/##Strasse##/g, f.strasse || '');
    result = result.replace(/##Hausnummer##/g, f.hausnummer || '');

    return result;
  }

  //
  // --------------------- SAVE
  //

  /**
   *
   *
   * @return {*}
   * @memberof TransferEditComponent
   */
  saveChanges() {
    console.log('submit');

    this.submitted = true;

    console.log('------- PRINT INVALID CONTROLS ---');
    for (let el in this.frmMandat.controls) {
      if (this.frmMandat.controls[el].errors) {
        console.log(el);
      }
    }

    // display form values on success
    this.submitted = true;
    if (this.frmMandat.valid) {
      // console.table(this.firstVisitorForm.value);
    }

    this.frmMandat.markAsPristine();
    this.isLoading = false;

    this.updateTatbestandNr(); // update also the tatbestand info

    // Ensure all 4 tatzeit fields are set (even as empty strings) before saving
    if (!this.frmMandat.value.tat_datum) {
      this.frmMandat.patchValue({ tat_datum: '' });
    }
    if (!this.frmMandat.value.tat_zeit) {
      this.frmMandat.patchValue({ tat_zeit: '' });
    }
    if (!this.frmMandat.value.tatzeit_bis_datum) {
      this.frmMandat.patchValue({ tatzeit_bis_datum: '' });
    }
    if (!this.frmMandat.value.tatzeit_bis_uhrzeit) {
      this.frmMandat.patchValue({ tatzeit_bis_uhrzeit: '' });
    }

    console.log(this.frmMandat.value);

    // update to the server
    this.mandatService.updateMandat(this.frmMandat.value).subscribe(
      (response: any) => {
        //next() callback
        console.log('response received');
        console.log(response);

        // broadcast the changes back to the table-view
        this.broadcastChanges(response);

        // refresh the journal timeline so the new "Mandat bearbeitet" entry appears
        this.getAllJournalItems(this.mandat_id, this.mandat.Md_BelegNr);

        this._snackBar.open('Saved successfully', 'Close', {
          duration: 1000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });

        //
        // show some feedback --> snackbar ?
        //
      },
      (error) => {
        //error() callback
        console.error('Request failed with error');
        //this.errorMessage = error;
      },
      () => {
        //complete() callback
        console.log('Request completed'); //This is actually not needed
      }
    );
  }
}
